// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simple-config-container[data-v-3ef573df] {\n  padding: 20px;\n}\n.form-tip[data-v-3ef573df] {\n  font-size: 12px;\n  color: #909399;\n  margin-top: 5px;\n}\n[data-v-3ef573df] .el-table th {\n  background-color: #f5f7fa;\n}", ""]);
// Exports
module.exports = exports;
